import { Routes } from "@angular/router";
import { keycloakGuard } from "@ogs/ngx-keycloak";
import { EMPTY_ROUTE } from "@shared/common/routes.common";
import { AUTHENTICATE_ROUTES_NAMES_DEFINITION } from "@features/authenticate/constants/auth-routes.constant";
import { CORE_ROUTE_NAMES } from "./core-route-names";


export const CORE_ROUTES: Routes = [
  {
    path: CORE_ROUTE_NAMES.authenticate,
    loadChildren: async (): Promise<typeof AUTHENTICATE_ROUTES_NAMES_DEFINITION> => await import("@features/authenticate/constants/auth-routes.constant").then((m) => m.AUTHENTICATE_ROUTES_NAMES_DEFINITION)
  },
  {
    path: EMPTY_ROUTE,
    canMatch: [
      keycloakGuard()
    ],
    loadChildren: async () => await import("./secure-routes.const").then((m) => m.SECURE_ROUTES)
  }
];
